<template>
  <div class="identity-verification">
    <!-- 详情头 -->
    <a-space align="center">
      <a-icon type="left" style="font-size: 23px" @click="changeToInfoDetail" />
      <div
        class="ant-descriptions-title"
        style="font-size: 16px; margin-bottom: 0px"
      >
        企业认证
      </div>
    </a-space>

    <!-- 步骤条 -->
    <a-steps
      :current="currentStep"
      style="margin-bottom: 30px; margin-top: 20px"
    >
      <a-step title="上传营业执照" />
      <a-step title="上传授权委托书" />
      <a-step title="提交完成" />
    </a-steps>

    <div v-show="currentStep === 0" style="margin-top: 40px">
      <BusinessLicense ref="businessLicenseRef"></BusinessLicense>
      <div class="action-buttons">
        <a-button @click="certnextStep" type="primary" size="large"
          >下一步</a-button
        >
      </div>
    </div>

    <div v-show="currentStep === 1" style="margin-top: 40px">
      <AuthorizationDocument ref="authorizationDocumentRef"></AuthorizationDocument>
      <div class="action-buttons">
        <a-button @click="prevStep" v-show="currentStep === 1" size="large"
          >返回</a-button
        >
        <a-button
          @click="validateForSubmit"
          type="primary"
          size="large"
          >提交</a-button
        >
      </div>
    </div>

    <div v-if="currentStep === 2">
      <a-result
        status="info"
        title="企业认证审核中"
        sub-title="您的企业认证信息已提交成功，目前正在进行人工审核，请耐心等待审核结果。审核通过后，您可返回业务页面继续后续操作"
      >
        <template #extra>
          <a-button @click="changeToInfoDetail"> 返回 </a-button>
        </template>
      </a-result>
    </div>
  </div>
</template>

<script>
import BusinessLicense from "./verifyInfo/BusinessLicense";
import AuthorizationDocument from "./verifyInfo/AuthorizationDocument";
export default {
  components: {
    BusinessLicense,
    AuthorizationDocument,
  },
  data() {
    return {
      currentStep: 0, // 当前步骤
      BusinessLicenseFormData: {},
      authorizationDocumentFormData:{}
    };
  },
  methods: {
    changeToInfoDetail() {
      console.log;
      this.$emit("changeToInfoDetail");
    },
    async certnextStep() {
      const res = await this.$refs.businessLicenseRef.validateForNextStep();

      if (!res.valid) return;
      this.BusinessLicenseFormData = res.data;
      this.currentStep++;
    },

    async validateForSubmit() {
      const res = await this.$refs.authorizationDocumentRef.validateForSubmit();

      if (!res.valid) return;
      this.authorizationDocumentFormData = res.data;
      
      this.currentStep++;
    },

    prevStep() {
      if (this.currentStep > 0) {
        this.currentStep--;
      }
    },
  },
};
</script>

<style scoped>
.identity-verification {
  padding: 20px;
}

.verification-content {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

.qr-section {
  text-align: center;
}

.left-section {
  width: 48%;
}

.right-section {
  width: 48%;
}

.vertical-divider {
  width: 1px;
  background-color: #e8e8e8;
  margin: 0 20px;
}

.upload-item {
  margin-bottom: 20px;
  margin-top: 10px;
}

.upload-box {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.upload-icon {
  font-size: 24px;
  color: #1890ff;
  margin-right: 10px;
}

.upload-btn {
  margin-top: 10px;
}

.personal-info {
  background-color: #f9f9f9;
  padding: 10px;
  border-radius: 5px;
}

.info-item {
  display: flex;
  margin-bottom: 24px;
}

.label {
  font-weight: bold;
  margin-right: 10px;
}

.error-msg {
  color: red;
  font-size: 12px;
}

.action-buttons {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  gap: 20px;
}
/* 输入框高度统一 */
.right-section /deep/ input.ant-input {
  height: 32px !important;
  border-radius: 4px;
}
</style>
